<template>
  <div class="template-preview">
    <aha-modal
      width="1200px"
      @hide="$emit('hide')"
      hideHeader
      :noMarginPadding="true"
    >
      <TemplatePreview
        :presentationShareCode="presentationShareCode"
        :templateLocation="templateLocation"
        :isPopupMode="true"
        :where="where"
      />
      <aha-icon
        class="close-button"
        name="close"
        height="20"
        width="20"
        viewBox="0 0 24 24"
        @click="$emit('hide')"
      />
    </aha-modal>
  </div>
</template>

<script>
import TemplatePreview from './TemplatePreview.vue'
import EventBus from '@/eventBus'

export default {
  components: {
    TemplatePreview,
  },
  props: {
    presentationShareCode: {
      type: String,
      required: true,
    },
    templateLocation: {
      type: String,
      default: 'template library',
    },
    where: {
      type: String,
      default: 'Newly added',
    },
  },
  mounted() {
    EventBus.$on('hide-modal-preview-template', () => {
      this.$emit('hide')
    })
  },
  destroyed() {
    EventBus.$off('hide-modal-preview-template')
  },
}
</script>
<style lang="scss" scoped>
.close-button {
  @apply cursor-pointer text-base-70 hover:text-primary-90;
  @apply absolute;
  top: 10px;
  right: 20px;

  @media screen and (max-width: 767px) {
    top: 40px;
    right: 16px;
  }
}
</style>
